var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import moment from 'moment';
import { withTranslation } from 'react-i18next';
import CheckoutListItem from '../../Cart/partials/CheckoutListItem';
import CurrencyFormatter from '../../../core/utils/currency-formatter';
var OrderListItem = /** @class */ (function (_super) {
    __extends(OrderListItem, _super);
    function OrderListItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isOpen: false,
        };
        return _this;
    }
    OrderListItem.prototype.render = function () {
        var _this = this;
        var _a;
        return (React.createElement("div", { className: "c-order-list-item" },
            React.createElement("div", { className: "c-order-list-item__top" },
                React.createElement("div", { className: "c-order-list-item__top__left" },
                    React.createElement("ul", { className: "c-description-list" },
                        React.createElement("li", null,
                            React.createElement("span", null, this.props.t('account.orders.date.title')),
                            moment((_a = this.props.item.paid_at) !== null && _a !== void 0 ? _a : this.props.item.created_at).format('LL')),
                        React.createElement("li", null,
                            React.createElement("span", null, this.props.t('account.orders.amount.title')),
                            CurrencyFormatter.format(this.props.item.getTotal(), this.props.item.currency.format)))),
                React.createElement("div", { className: "c-order-list-item__top__right" },
                    React.createElement("i", { className: "h-cursor--pointer icon-" + (this.state.isOpen ? 'up' : 'down'), onClick: function () { return _this.setState({ isOpen: !_this.state.isOpen }); } }))),
            this.state.isOpen && (React.createElement("div", { className: "c-order-list-item__bottom" },
                React.createElement("ul", { className: "c-description-list" },
                    React.createElement("li", null,
                        React.createElement("span", null, this.props.t('account.orders.shipping_address.title')),
                        this.props.item.getAddress()),
                    React.createElement("li", null,
                        React.createElement("span", null, this.props.t('account.orders.payment_method.title')),
                        this.props.t(!this.props.item.is_paid ? 'account.orders.payment.unpaid' : 'account.orders.payment.bank_card'))),
                React.createElement("div", { className: "c-order-list-item__items" },
                    React.createElement("h2", null, this.props.t('account.orders.items.title')),
                    React.createElement("div", { className: "c-order-list-item__items__content" }, this.props.item.cart_items.map(function (item, key) { return (React.createElement(CheckoutListItem, { key: key, item: item, hideGrossTotal: true })); }))),
                React.createElement("div", { className: "c-order-list-item__invoice" },
                    React.createElement("div", { className: "c-order-list-item__invoice__button" }, this.renderInvoiceDownloadButton()))))));
    };
    OrderListItem.prototype.renderInvoiceDownloadButton = function () {
        var _a, _b;
        var invoiceUrl = null;
        if (((_a = this.props.item.invoices) === null || _a === void 0 ? void 0 : _a.length) && ((_b = this.props.item.invoices[0].provider_invoice) === null || _b === void 0 ? void 0 : _b.filename)) {
            invoiceUrl = "/storage/invoices/" + this.props.item.invoices[0].provider_invoice.filename;
        }
        var button = (React.createElement("button", { className: "c-btn c-btn--pink-100 c-btn--icon-right c-btn--full", disabled: !invoiceUrl },
            this.props.t('account.orders.invoice_button'),
            React.createElement("i", { className: "icon-invoice" })));
        if (invoiceUrl) {
            return (React.createElement("a", { href: invoiceUrl, target: "_blank", className: "c-btn__link" }, button));
        }
        return button;
    };
    return OrderListItem;
}(React.Component));
export default withTranslation()(OrderListItem);
